import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import UserDataTable from '../../../components/userAdminPanel/Components/UserDataTable/UserDataTable';
import { allUserAssetsColumns } from '../../../datatablesource';
import { handleUserError } from '../../../utils/error';
import userRequest from "../../../utils/userRequest";
import "../Styles/PrintingAsset.scss";
import ViewportMeta from '../../../utils/ViewportMeta';
import { useTranslation } from 'react-i18next';

const PrintingAsset2 = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation()
  const [data, setData] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [allAssetsList, setAllAssetsList] = useState([]);
  useEffect(() => {
    const getAllAssetsList = async () => {
      try {

        userRequest.get("/GetAllAssetMasterEncodeAssetCapture", data)
          .then(response => {
            setAllAssetsList(response?.data ?? []);
            setIsAuthenticating(false)
          })
          .catch(error => {
            handleUserError(error)
            setIsAuthenticating(false)

          });
      }
      catch (error) {
        console.log(error);
        setIsAuthenticated(false);
        setIsAuthenticating(false);
        // navigate("/userLogin");
      }
    };
    getAllAssetsList();
  }, []);

  return (
    <>

      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
        <ViewportMeta />
        <UserDataTable data={allAssetsList} columnsName={allUserAssetsColumns(t)} title={t("PRINTING ASSETS")} backButton={true}
          UniqueId="assetPrintingId"
          secondaryColor='secondary'
          loading={isAuthenticating}
          deleteBtnEndPoint="/DeleteAssetMasterEncodeAssetCaptureById"
        />
      </div>

    </>
  )
}

export default PrintingAsset2